import { useEffect, useRef, DependencyList } from "react";

export function useDebounceEffect(
  fn: () => void,
  waitTime: number,
  deps: DependencyList = []
) {
  const savedFn = useRef(fn);

  useEffect(() => {
    savedFn.current = fn;
  }, [fn]);

  useEffect(() => {
    const handler = setTimeout(() => {
      savedFn.current();
    }, waitTime);

    return () => {
      clearTimeout(handler);
    };
  }, [waitTime, ...deps]); // Include waitTime and dependencies
}
